import { render, staticRenderFns } from "./ImportGroups.vue?vue&type=template&id=ccd95884&scoped=true"
import script from "./ImportGroups.vue?vue&type=script&lang=js"
export * from "./ImportGroups.vue?vue&type=script&lang=js"
import style0 from "./ImportGroups.vue?vue&type=style&index=0&id=ccd95884&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccd95884",
  null
  
)

export default component.exports